/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { useApi } from "utils"


export type Customer = {
    customer_id: number
    customer_name: string
    payment_term_id: number | null
    payment_term_name: number | null
    country_name?: string
    province_name?: string
    regency_name?: string
    subdistrict_name?: string
    village_name?: string
    address?: string
    price_level_name?: string
}
  

export type Response = {
  payload: Customer[]
}

export function useCustomerList() {
  const api = useApi()
  const [data, setData] = useState<Response["payload"]>([])
  const [isLoading, setLoading] = useState(false)

  const fetchData = () => {
    setLoading(true)

    api
      .get("/customer/")
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload

        setData(data)
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false))
  }

  const refetch = () => fetchData()

  useEffect(() => {
    fetchData()

    return () => {
      setData([])
      setLoading(false)
    }
  }, [])

  return {
    data,
    isLoading,
    dropdown: data?.map((item) => ({
      ...item,
      label: item.customer_name,
      value: item.customer_id.toString()
    })),
    refetch
  }
}
